module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.longTextValue) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs p-general-damages"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "label": _vm.name ? 'Type of ' + _vm.name : 'Category of Injury',
      "tip-show": !!!_vm.name,
      "tip-text": "This section is based on the General Damages 14th edition of the Judicial College Guidelines.",
      "tip-icon": "info",
      "tip-side": "right",
      "tip-width": "250",
      "tip-name": "general_damages_award_narrative"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.injuryTypeId),
      expression: "injuryTypeId"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.injuryTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectInjury()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _vm._l((_vm.tree), function(category, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                        " + _vm._s(category.index ? category.index : '') + " " + _vm._s(category.name) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [(_vm.hasDescription()) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.tree[_vm.injuryTypeId]['name']))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tree[_vm.injuryTypeId]['description'])
    }
  })]) : _vm._e()])]) : _c('div', {
    staticClass: "a-form-inputs p-general-damages p-general-damages__long-text"
  }, [_c('label', [_vm._v(_vm._s(_vm.name ? 'Type of ' + _vm.name : 'Category of Injury'))]), _vm._v(" "), _c('div', [_c('ul', _vm._l((_vm.tree), function(category, index) {
    return _c('li', [_c('button', {
      staticClass: "a-button",
      class: [_vm.injuryTypeId === index ? 'disabled' : ''],
      on: {
        "click": function($event) {
          return _vm.updateRadioButtons(index)
        }
      }
    }, [(_vm.injuryTypeId === index) ? _c('span', [_vm._v("Selected")]) : _c('span', [_vm._v("Select Award")])]), _vm._v(" "), _c('div', {
      staticClass: "a-radio u-d-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.injuryTypeId),
        expression: "injuryTypeId"
      }],
      attrs: {
        "type": "radio",
        "name": 'injuryTypeRadio' + index
      },
      domProps: {
        "value": index,
        "checked": _vm._q(_vm.injuryTypeId, index)
      },
      on: {
        "click": function($event) {
          return _vm.selectInjury()
        },
        "change": function($event) {
          _vm.injuryTypeId = index
        }
      }
    })]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.updateRadioButtons(index)
        }
      }
    }, [_vm._v(_vm._s(category.index ? category.index : '') + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(category.name)
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasChildren()) ? _c('injury-select', {
    ref: "childSelect",
    attrs: {
      "level": (_vm.level + 1),
      "selected": _vm.selected,
      "awardIndex": _vm.awardIndex,
      "tree": _vm.tree[_vm.injuryTypeId]['children'],
      "name": _vm.tree[_vm.injuryTypeId]['name'],
      "long-text-value": _vm.longText
    },
    on: {
      "injury-selected": _vm.bubbleSelected,
      "award-selected": _vm.updateValid
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasChildren() && _vm.injuryTypeId !== null) ? _c('div', [_c('h2', [_vm._v("The Range - JC Guidelines Chapter " + _vm._s(_vm.getJCGuidelinesInfo(_vm.awardIndex)))]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-margin-top-30 a-form-inputs p-general-damages"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid--column"
  }, [_c('h3', [_vm._v("\n                        With 10% Uplift\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasValue('up_to_value_with_uplift')) ? _c('span', [_vm._v("\n                        Up to: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['up_to_value_with_uplift'])) + " ")])]) : (_vm.hasValue('in_the_region_of_with_uplift')) ? _c('span', [_vm._v("\n                        In the region of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_the_region_of_with_uplift'])) + " ")])]) : (_vm.hasValue('in_excess_of_with_uplift')) ? _c('span', [_vm._v("\n                        In excess of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_excess_of_with_uplift'])) + " ")])]) : (_vm.hasValue('a_few_hundred_pounds_to_with_uplift')) ? _c('span', [_vm._v("\n                        A few hundred pounds to:  "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['a_few_hundred_pounds_to_with_uplift'])) + " ")])]) : (_vm.hasValue('not_less_than_with_uplift')) ? _c('span', [_vm._v("\n                        Not less than: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['not_less_than_with_uplift'])) + " ")])]) : (_vm.hasValue('rarely_exceed_with_uplift')) ? _c('span', [_vm._v("\n                        Rarely exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['rarely_exceed_with_uplift'])) + " ")])]) : (_vm.hasValue('likely_to_exceed_with_uplift')) ? _c('span', [_vm._v("\n                        Likely to exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['likely_to_exceed_with_uplift'])) + " ")])]) : _c('div', [(_vm.hasValue('lower_value_with_uplift')) ? _c('span', [_vm._v("\n                            Lower Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['lower_value_with_uplift'])) + " ")]), _vm._v(" to\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.hasValue('upper_value_with_uplift')) ? _c('span', [_vm._v("\n                            Upper Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['upper_value_with_uplift'])) + " ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [_vm.uplift ? 'disabled' : ''],
    attrs: {
      "disabled": _vm.uplift
    },
    on: {
      "click": function($event) {
        return _vm.adjustUplift()
      }
    }
  }, [(_vm.uplift) ? _c('span', [_vm._v("Selected")]) : _c('span', [_vm._v("Select")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "flex-grid--column"
  }, [_c('h3', [_vm._v("\n                        Without 10% Uplift\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasValue('up_to_value')) ? _c('span', [_vm._v("\n                        Up to: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['up_to_value'])) + " ")])]) : (_vm.hasValue('in_the_region_of')) ? _c('span', [_vm._v("\n                        In the region of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_the_region_of'])) + " ")])]) : (_vm.hasValue('in_excess_of')) ? _c('span', [_vm._v("\n                        In excess of: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['in_excess_of'])) + " ")])]) : (_vm.hasValue('a_few_hundred_pounds_to')) ? _c('span', [_vm._v("\n                        A few hundred pounds to:  "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['a_few_hundred_pounds_to'])) + " ")])]) : (_vm.hasValue('not_less_than')) ? _c('span', [_vm._v("\n                        Not less than: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['not_less_than'])) + " ")])]) : (_vm.hasValue('rarely_exceed')) ? _c('span', [_vm._v("\n                        Rarely exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['rarely_exceed'])) + " ")])]) : (_vm.hasValue('likely_to_exceed')) ? _c('span', [_vm._v("\n                        Likely to exceed: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['likely_to_exceed'])) + " ")])]) : _c('div', [(_vm.hasValue('lower_value')) ? _c('span', [_vm._v("\n                            Lower Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['lower_value'])) + " ")]), _vm._v(" to\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.hasValue('upper_value')) ? _c('span', [_vm._v("\n                            Upper Value: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(" " + _vm._s(_vm.currencyFormat(_vm.tree[_vm.injuryTypeId]['upper_value'])) + " ")])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [!_vm.uplift ? 'disabled' : ''],
    attrs: {
      "disabled": !_vm.uplift
    },
    on: {
      "click": function($event) {
        return _vm.adjustUplift()
      }
    }
  }, [(_vm.uplift) ? _c('span', [_vm._v("Select")]) : _c('span', [_vm._v("Selected")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs u-margin-top-10"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('h3', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("General Damages")]), _vm._v(" "), _c('control', {
    attrs: {
      "name": "general_damages_award",
      "tip-text": _vm.generalDamages === _vm.low || _vm.generalDamages === _vm.lowUplift ? 'This is the lower award.' : _vm.generalDamages === _vm.mid || _vm.generalDamages === _vm.midUplift ? 'This is the mid-range between the lower and upper award.' : _vm.generalDamages === _vm.upper || _vm.generalDamages === _vm.upperUplift ? 'This is the upper award.' : '',
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "general_damages_award_narrative",
      "tip-show": !!(_vm.low || _vm.lowUplift || _vm.upper || _vm.upperUplift),
      "no-flex-margin": true,
      "table-control": true
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "min": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "change": _vm.updateValid,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', [(_vm.hasValue('lower_value')) ? _c('div', [_c('button', {
    staticClass: "a-button",
    class: [_vm.generalDamages === _vm.low || _vm.generalDamages === _vm.lowUplift ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.applyAward('lower')
      }
    }
  }, [_vm._v("Apply Lower")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [_vm.generalDamages === _vm.mid || _vm.generalDamages === _vm.midUplift ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.applyAward('mid')
      }
    }
  }, [_vm._v("Apply Mid")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    class: [_vm.generalDamages === _vm.upper || _vm.generalDamages === _vm.upperUplift ? 'disabled' : ''],
    on: {
      "click": function($event) {
        return _vm.applyAward('upper')
      }
    }
  }, [_vm._v("Apply Upper")])]) : _vm._e()])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8696422!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/components/InjurySelect.vue
// module id = 1785
// module chunks = 0